module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// /Volumes/Data HD/Git-UI/uikit-fullscreen/~/babel-polyfill/~/core-js/modules/_iter-step.js
// module id = 102
// module chunks = 0